import { render, staticRenderFns } from "./returnPayFeeManageList.vue?vue&type=template&id=21bc8583&scoped=true"
import script from "./returnPayFeeManageList.vue?vue&type=script&lang=js"
export * from "./returnPayFeeManageList.vue?vue&type=script&lang=js"
import style0 from "./returnPayFeeManageList.vue?vue&type=style&index=0&id=21bc8583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc8583",
  null
  
)

export default component.exports